import { IsOptional, IsNotEmpty, IsUUID, IsString } from 'class-validator';

import { UserRoleEnum } from '@app/types';

export class GetCanCreateBatchEventOrEventForAnotherEmployeeDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsUUID()
  @IsOptional()
  parentEventId?: string;

  @IsString()
  @IsOptional()
  role?: UserRoleEnum;
}
